import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const apiUrl = Config.apiUrl;

const CashRegisterList = () => {
    const [cashRegisters, setCashRegisters] = useState([]);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery() {
        try {
            setLoading(true);
            const url = apiUrl + '/api/cash-registers';
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setCashRegisters(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, []);

    return (
        <>
            <div className="header-label">Histórico de Caixa</div>

            <table style={{width: '100%'}}>
                <thead>
                <tr>
                    <th>Aberto em</th>
                    <th>Aberto por</th>
                    <th>Valor de abertura</th>
                    <th>Fechado em</th>
                    <th>Fechado por</th>
                    <th/>
                </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                {cashRegisters.map((cashRegister, index) => (
                    <tr key={index}>
                        <td>{new Date(cashRegister.openedAt).toLocaleString('pt-BR')}</td>
                        <td>{cashRegister.openedByUser?.name}</td>
                        <td>
                            <div style={{textAlign: 'right'}}>
                                R$ {cashRegister.openingValue.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                            </div>
                        </td>
                        <td>{cashRegister.closedAt ? new Date(cashRegister.closedAt).toLocaleString('pt-BR') : 'Aberto'}</td>
                        <td>{cashRegister.closedByUser?.name ?? ''}</td>
                        <td>
                            <button onClick={() => navigate('/cashregisterreport?id=' + cashRegister.id)}>
                                Relatório
                            </button>
                        </td>
                    </tr>
                ))}
                {cashRegisters.length === 0 && <tfoot>Nenhum item encontrado.</tfoot>}
                </tbody>
            </table>
        </>
    );
};

export default CashRegisterList;
